import { ErrorBoundary } from '@genial/components';
import React from 'react';

export const DividendHistoryItemEmpty: React.FC = () => {
  return (
    <ErrorBoundary
      errorIconOrIllustration="NotFoundIllustration"
      errorMessage="Por favor, verifique o campo informado e tente novamente."
      errorTitle="Nenhum resultado corresponde à sua pesquisa"
    />
  );
};
